export class Personne {
    num: string;
    nom: string;
    prenom: string;
    adresse: string;
    cp: string;
    ville: string;
    mail: string;
    telephone: string;
    type: string;
    //photo: string;

  constructor() {
  }
}